import SmoothScroll from 'smooth-scroll'

const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 500,
    speedAsDuration: true,
    easing: 'easeInOutCubic',
    offset: () => window.innerWidth > 768 ? 70 : 0
})